export default __webpack_public_path__ + "static/media/gb.9a1a5e8a.svg";